// extracted by mini-css-extract-plugin
module.exports = {"disclaimer_container":"Disclaimer_disclaimer_container__JaAQK","disclaimer_tag":"Disclaimer_disclaimer_tag__0Uo9j"};